/* tslint:disable */
/* eslint-disable */
export enum PublicPaymentDetailApplicationExpenseType {
  None = 'None',
  MortgageOrRent = 'MortgageOrRent',
  Utilities = 'Utilities',
  Transport = 'Transport',
  Groceries = 'Groceries',
  Entertainment = 'Entertainment',
  Insurance = 'Insurance',
  ClothingShoesPersonalCare = 'ClothingShoesPersonalCare',
  Rates = 'Rates',
  Accommodation = 'Accommodation',
  Medical = 'Medical',
  EducationChildcare = 'EducationChildcare',
  ChildSupport = 'ChildSupport',
  GivingTithing = 'GivingTithing'
}
